<template>
    <div class="layout-default">
        <scroll-to-top/>
        <div class="container-fluid">
            <top-bar @setShowSearch="setShowSearch($event)"></top-bar>
            <div v-show="showSearch === true && showGlobalChildFilter === false">
                <div class="row">
                    <div class="col-12 col-sm-10 ms-sm-auto me-sm-auto">
                    <br>
                    <br>
                    <child-search @close="setShowSearch(false)"></child-search>
                    </div>
                </div>
            </div>
            <div v-if="showGlobalChildFilter === true && showSearch === false">
                <div class="row">
                    <div class="col-12 col-sm-10 ms-sm-auto me-sm-auto">
                    <br>
                    <br>
                    <selective-child-view/>
                    </div>
                </div>
            </div>
            <div v-if="showSearch === false && showGlobalChildFilter === false">
                <div class="row" style="min-height: 100vh">
                    <div v-if="showMainNavbar" class="col-12 col-sm-2 col-md-1" style="background: #505761; color: #bdc7d4; padding: 0;">
                    <main-navbar></main-navbar>
                    </div>
                    <div v-if="showMainNavbar" class="col-12 col-sm-10 col-md-11" style="padding: 15px; padding-left: 20px; padding-right: 20px;">
                        <!-- margin so scroll-to-top doesn't hinder underlying buttons -->
                        <router-view style="margin-bottom: 200px"></router-view>
                    </div>
                    <div v-else class="col-12" style="padding-top: 15px; padding-bottom: 15px">
                        <!-- margin so scroll-to-top doesn't hinder underlying buttons -->
                        <router-view style="margin-bottom: 200px"></router-view>
                    </div>
                </div>
            </div>
        </div>
        <side-navbar v-show="showSideNavbar"></side-navbar>
    </div>
</template>

<script>
import ChildSearch from '@/components/Child-Search'
import MainNavbar from '@/components/Main-Navbar'
import SideNavbar from '@/components/Side-Navbar'
import ScrollToTop from '@/components/Scroll-To-Top'
import TopBar from '@/components/Top-Bar'
import SelectiveChildView from '@/components/Selective-Child-View'
export default {
  name: 'layout-default',
  components: {
    ChildSearch,
    MainNavbar,
    SideNavbar,
    ScrollToTop,
    TopBar,
    SelectiveChildView
  },
  computed: {
    showSearch () {
        return this.$store.getters.showSearch
    },
    showGlobalChildFilter () {
        return this.$store.getters.showGlobalChildFilter
    },
    showMainNavbar () {
        return this.$store.getters.showMainNavbar
    },
    showSideNavbar () {
        return this.$store.getters.showSideNavbar
    }
  }
}
</script>

<style scoped>
</style>
